export const calculateInvoiceTotals = (items, globalDiscount = 0) => {
  const subtotal = items.reduce((sum, item) => {
    const itemTotal = (item.qty || 0) * (item.price || 0);
    const itemDiscount = itemTotal * ((item.discount || 0) / 100);
    return sum + (itemTotal - itemDiscount);
  }, 0);

  const taxTotal = items.reduce((sum, item) => {
    const itemTotal = (item.qty || 0) * (item.price || 0);
    const itemDiscount = itemTotal * ((item.discount || 0) / 100);
    const taxableAmount = itemTotal - itemDiscount;
    return sum + (taxableAmount * ((item.taxRate || 0) / 100));
  }, 0);

  const discountAmount = subtotal * (globalDiscount / 100);
  const total = subtotal + taxTotal - discountAmount;

  return {
    subtotal: subtotal.toFixed(2),
    taxTotal: taxTotal.toFixed(2),
    discountAmount: discountAmount.toFixed(2),
    total: total.toFixed(2)
  };
};

export const generateInvoiceNumber = (lastNumber = 10000) => {
  return `INV-${lastNumber + 1}`;
};